import type { OpenAPISpec } from '@gitbook/api-client';
import * as analytics from '@gitbook/app-analytics/client';
import { createPalette, PaletteButton } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { DialogRoot, useOverlayTriggerState } from '@gitbook/spine-react';

import { confirmOpenAPISpecDelete, OpenAPISpecEditDialog } from '../../Components';
import { useNavigation } from '../../navigation';

export function OpenAPISpecActionsButton(props: {
    organizationId: string;
    openAPISpec: OpenAPISpec;
}) {
    const { organizationId, openAPISpec } = props;
    const { navigate } = useNavigation();
    const editDialogTrigger = useOverlayTriggerState({
        onOpenChange: (isOpen) => {
            if (isOpen) {
                analytics.logEvent({
                    type: 'openapi_spec_edit_intent',
                    organization: organizationId,
                    specSlug: openAPISpec.slug,
                    triggerLocation: 'header',
                    trigger: 'menu-action',
                });
            }
        },
    });
    const canAddOpenAPISpec = openAPISpec.permissions.edit;
    if (!canAddOpenAPISpec) {
        return null;
    }
    return (
        <>
            <PaletteButton
                palette={() =>
                    createPalette({
                        groups: [
                            {
                                key: 'actions',
                                commands: [
                                    {
                                        key: 'edit',
                                        title: 'Edit',
                                        icon: Icon.Edit,
                                        trigger: () => {
                                            editDialogTrigger.open();
                                        },
                                    },
                                    {
                                        key: 'delete',
                                        title: 'Delete',
                                        icon: Icon.Trashcan,
                                        trigger: () => {
                                            void confirmOpenAPISpecDelete({
                                                openAPISpec,
                                                organizationId,
                                                navigate,
                                            });
                                        },
                                    },
                                ],
                            },
                        ],
                    })
                }
                size="small"
                kind="blank"
                label="Actions"
                leadingIcon={Icon.MoreHorizontal}
                iconOnly
            />
            <DialogRoot {...editDialogTrigger.rootProps}>
                <OpenAPISpecEditDialog openAPISpec={openAPISpec} organizationId={organizationId} />
            </DialogRoot>
        </>
    );
}
